// create strategies for other type of files
// the accept prompt should be separated by comma and space --> ", "
export const fileExtensions = {
  image: {
    accept: ['image/png', 'image/gif', 'image/jpeg'],
    label: 'file-upload.uploadImageLabel',
  },
  profileImage: {
    accept: ['image/png', 'image/jpeg'],
    label: 'file-upload.uploadProfileImageLabel',
  },
  logotype: {
    accept: ['image/png'],
    label: 'file-upload.uploadLogotypeLabel',
  },
  document: {
    accept: [
      'text/plain',
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'text/csv',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/xml',
      'text/xml'
    ],
    label: 'file-upload.uploadDocumentLabel',
  },
  csv: {
    accept: ['text/csv'],
    label: 'file-upload.uploadCSVLabel',
  },
  xml: {
    accept: ['text/xml'],
    label: 'file-upload.uploadCSVLabel',
  }
};

export const extensionIcons = {
  pdf: 'picture_as_pdf',
  txt: 'title',
  docx: 'text_snippet',
  xlsx: 'grid_on',
  csv: 'view_list',
  default: 'upload_file',
};

export const docActionMenuItems = [
  {
    action: 'allow_rename',
    label: 'file-upload.renameLabel',
  },
];

export const fileEntityTypes = {
  Suppliers: {
    title: 'supplier.importNew',
    entity: 'Suppliers',
    collection: 'Supplier',
    action: 'importSuppliers',
    dataInstructions: {
      paragraph: 'file-upload.instructions-suppliers'
    },
    route: '/users',
  } as IFileEntity,
  Users: {
    title: 'users.importNew',
    entity: 'Users',
    collection: 'User',
    action: 'importUsers',
    dataInstructions: {
      paragraph: 'file-upload.instructions-users',
      image: '/assets/img/users-fields-sample.png',
    },
    route: '/users',
  } as IFileEntity,
  Items: {
    title: 'item-catalog.importNewItems',
    entity: 'Items',
    collection: 'Item',
    action: 'importItems',
    dataInstructions: {
      paragraph: 'file-upload.instructions-items',
      image: '/assets/img/items-fields-sample.png',
    },
    route: '/items',
  },
  Invoices: {
    title: 'Import New Invoices',
    entity: 'Invoices',
    collection: 'Invoice',
    action: 'importItems',
    dataInstructions: {
      paragraph: 'file-upload.instructions-invoices-nemsis',
    },
    route: '/invoices',
  },
  Locations: {
    title: 'Import new locations',
    entity: 'Locations',
    collection: 'Location',
    action: 'importLocations',
    dataInstructions: {
      paragraph: 'file-upload.instructions-items',
      image: '/assets/img/locations-fields-sample.png',
    },
    route: '/locations',
  },
  Cribs: {
    title: 'crib.importNew',
    entity: 'Cribs',
    collection: 'Crib',
    action: 'importCribs',
    dataInstructions: {
      paragraph: 'file-upload.instructions-cribs',
      image: '/assets/img/cribs-fields-sample.png',
    },
    route: '/cribs-and-bins',
  },
  Bins: {
    title: 'bin.importNew',
    entity: 'Bins',
    entitySingular: 'Bin',
    collection: 'Bins',
    action: 'importBins',
    dataInstructions: {
      paragraph: 'file-upload.instructions-bins',
      image: '/assets/img/bins-fields-sample.png',
    },
    route: '/cribs-and-bins',
  },
  CostCenterValue: {
    title: 'cost-centers.import-new-value',
    entity: 'CostCenterValue',
    collection: 'CostCenterValue',
    action: 'importCostCenterValue',
    dataInstructions: {
      paragraph: 'file-upload.instructions-cost-center-values',
      image: '/assets/img/cost-center-values-fields-sample.png',
    },
    route: '/cost-centers',
    routeValue: '/cost-centers',
  },
  CostCenters: {
    title: 'cost-centers.import-cost-center',
    entity: 'CostCenters',
    collection: 'CostCenter',
    action: 'importCCs',
    dataInstructions: {
      paragraph: 'file-upload.instructions-cost-centers',
      image: '/assets/img/cost-centers-fields-sample.png',
    },
    route: '/cost-centers',
    routeValue: '/cost-centers',
  },
FireIncidents: {
  title: 'Import New',
  entity: 'FireIncident',
  collection: 'FireIncident',
    action: 'importCCs',
    dataInstructions: {
      paragraph: 'file-upload.instructions-fie-incident',
      image: '/assets/img/cost-centers-fields-sample.png',
    },
    route: '/fire-incidents',
  routeValue: '/fire-incidents',
  }
};

export enum FileTypeEnum {
  IMAGES = 'Images',
  DOCUMENTS = 'Documents',
  PROFILE = 'Profile',
}

export enum FileUploadStatusEnum {
  UPLOADING,
  INPROCESS,
  CANCELED,
  FAILED,
  FINISHED,
}

export interface IFile {
  index: number;
  name: string;
  size?: number;
  sizeInKB?: string;
  url?: string;
  isNew?: boolean;
  savingName?: boolean;
  editName?: boolean;
  fileBinary?: File;
  status: FileUploadStatusEnum;
  uploadFlow: boolean;
  fileEntity?: IFileEntity;
  type?: FileTypeEnum;
  importId?: string;
  hasParsingError?: boolean;
  hasParsingErrorDetail?: string;
}

export interface IFileEntity {
  title: string;
  entity: string;
  collection: string;
  action: string;
  entityId?: string;
  entitySingular?: string;
}
